import { pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import * as React from "react";
import { getDefaultKeyPressHandler } from "util/helpers";
import { LoadingIndicator } from "./georgeComponents";

export const GdsFakeActionButton = ({
    children,
    color = "default",
    onClick,
    disabled,
    style,
    innerStyle,
    isLoading,
    fullWidth = true,
    className,
}: {
    children: React.ReactNode;
    color?: "default" | "primary";
    onClick?: () => void;
    disabled?: boolean;
    style?: React.CSSProperties;
    innerStyle?: React.CSSProperties;
    isLoading?: boolean;
    fullWidth?: boolean;
    className?: string;
}) => {
    const isPrimary = color === "primary";
    return (
        <pr.HFlexCentered
            style={{
                boxSizing: "border-box",
                minWidth: 163,
                cursor: onClick && !disabled ? "pointer" : "default",
                border: !isPrimary ? "2px solid #a3b5c9" : "2px solid transparent",
                padding: "6px 20px",
                borderRadius: theme.BORDER_RADIUS_FULL,
                userSelect: "none",
                display: fullWidth ? "flex" : "inline-flex",
                ...disabled ? { backgroundColor: ui.isDarkMode ? theme.themeColors.d_grey_200 : "#e5e5e5" } : {},
                ...style
            }}
            className={
                `${isPrimary && !disabled ? "theme-action-button-background-color" : ""} ${className ?? ""}`.trim()
            }
            onClick={disabled ? undefined : onClick}
            role="button"
            aria-disabled={disabled ? "true" : "false"}
            tabIndex={0}
            onKeyPress={getDefaultKeyPressHandler(onClick)}
        >
            {isLoading && <LoadingIndicator isLoading style={{ position: "absolute" }} />}
            <pr.P_16_CONTENT
                className={!isPrimary ? "theme-secondary-action-label-color" : undefined}
                style={{
                    // Hide text when loading, but keep space -> cannot completely hide with {!isLoading && <>},
                    // otherwise button will shrink during load for multiline buttons
                    visibility: isLoading ? "hidden" : "visible",

                    color: isPrimary ? "white" : undefined,
                    fontWeight: 600,
                    lineHeight: "24px",
                    textAlign: "center",
                    ...innerStyle
                }}
            >
                {children}
            </pr.P_16_CONTENT>
        </pr.HFlexCentered>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/GdsFakeActionButton.tsx